import ArchiveTemplatesTable from "@components/tables/archive-tables/archive-templates-table";
import styles from "./document-templates-archive.module.scss";

export const DocumentTemplatesArchive = () => {
  return (
    <>
      <ArchiveTemplatesTable className={styles.archive__table} />
    </>
  );
};
